import * as React from "react";
import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const IncidentIntelligenceApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "IncidentIntelligence" */ "./IncidentIntelligenceApp");
    return { default: namedExport.IncidentIntelligenceApp };
});

export const IncidentIntelligence: TeamAppConfig = {
    title: "Incident Intelligence",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Kusto-backed view of incident volume and complete ground-truth coverage from Guardian Eval.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["guardian", "incident", "ground truth"],
    app: IncidentIntelligenceApp,
    path: "/IncidentIntelligence"
};
